import React, { useEffect } from "react";
import { motion } from "framer-motion";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import Footer from "../Components/Footer";
import Nav from "./Nav";
import { data } from "../data/projects";
import { useTransitionOverlay } from "../context/TransitionContext";

function ProjectPage() {
  const location = useLocation();
  const paths = location.pathname.split("/");
  const { clearTransition } = useTransitionOverlay();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    // Clear the global transition overlay so it fades out and reveals
    // the already full-screen hero image on this page.
    const t = setTimeout(clearTransition, 120);
    return () => clearTimeout(t);
  }, [clearTransition]);

  return data?.map((item) => {
    if (item.url === paths[2]) {
      return (
        <React.Fragment key={item.url}>
          <Nav />

          <motion.div
            className="page"
            key="index"
            exit={{ width: "100%", transition: { duration: 1 } }}
          />
          <motion.div
            className="page2"
            animate={{
              left: "auto",
              right: 0,
              width: "0",
              transition: { duration: 0.5 },
            }}
          />

          <HeroContainer>
            <HeroImg
              src={item.image}
              alt={item.name}
              initial={{ scale: 1.06, opacity: 0.7 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            />
          </HeroContainer>

          <TitleContainer>
            <Wrapper>
              <Title
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.3 }}
              >
                {item.name}
              </Title>
            </Wrapper>
            <Wrapper>
              <ProjectType
                initial={{ y: 60, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.45 }}
              >
                {item.type}
              </ProjectType>
            </Wrapper>
          </TitleContainer>

          <WrapperContainer>
            <Wrapperft style={{ marginBottom: "50px" }}>
              <RevealBar
                initial={{
                  width: "0%",
                  top: 0,
                  height: "100%",
                  position: "absolute",
                }}
                whileInView={{ width: "100%", transform: "translateX(100%)" }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
              />
              <About
                className="title"
                initial={{ y: 92 }}
                whileInView={{ y: 0, transition: { duration: 1, delay: 0.5 } }}
                viewport={{ once: true }}
              >
                About the project.
              </About>
            </Wrapperft>
            <Wrapperft>
              <Pera
                initial={{ y: 50, opacity: 0 }}
                whileInView={{
                  y: 0,
                  opacity: 1,
                  transition: { duration: 1, delay: 0.5 },
                }}
                viewport={{ once: true }}
              >
                {item?.about}
              </Pera>
            </Wrapperft>

            <BottomContainer>
              <div>
                <Wrapperft>
                  <RevealBar
                    initial={{
                      width: "0%",
                      top: 0,
                      height: "100%",
                      position: "absolute",
                    }}
                    whileInView={{
                      width: "100%",
                      transform: "translateX(100%)",
                    }}
                    transition={{ duration: 1 }}
                    viewport={{ once: true }}
                  />
                  <About
                    className="title"
                    initial={{ y: 20 }}
                    whileInView={{
                      y: 0,
                      transition: { duration: 1, delay: 0.5 },
                    }}
                    viewport={{ once: true }}
                  >
                    Platform
                  </About>
                </Wrapperft>
                <Wrapperft>
                  <Pera
                    className="title"
                    initial={{ y: 16, opacity: 0 }}
                    whileInView={{
                      y: 0,
                      opacity: 1,
                      transition: { duration: 1, delay: 0.5 },
                    }}
                    viewport={{ once: true }}
                  >
                    {item.type}
                  </Pera>
                </Wrapperft>
              </div>
              <div>
                <Wrapperft>
                  <RevealBar
                    initial={{
                      width: "0%",
                      top: 0,
                      height: "100%",
                      position: "absolute",
                    }}
                    whileInView={{
                      width: "100%",
                      transform: "translateX(100%)",
                    }}
                    transition={{ duration: 1 }}
                    viewport={{ once: true }}
                  />
                  <About
                    className="title"
                    initial={{ y: 20 }}
                    whileInView={{
                      y: 0,
                      transition: { duration: 1, delay: 0.5 },
                    }}
                    viewport={{ once: true }}
                  >
                    Category
                  </About>
                </Wrapperft>
                <Wrapperft>
                  <Pera
                    className="title"
                    initial={{ y: 16, opacity: 0 }}
                    whileInView={{
                      y: 0,
                      opacity: 1,
                      transition: { duration: 1, delay: 0.5 },
                    }}
                    viewport={{ once: true }}
                  >
                    Other
                  </Pera>
                </Wrapperft>
              </div>
            </BottomContainer>

            <Tech>
              <Wrapperft>
                <RevealBar
                  initial={{
                    width: "0%",
                    top: 0,
                    height: "100%",
                    position: "absolute",
                  }}
                  whileInView={{ width: "100%", transform: "translateX(100%)" }}
                  transition={{ duration: 1 }}
                  viewport={{ once: true }}
                />
                <About
                  className="title"
                  initial={{ y: 20 }}
                  whileInView={{
                    y: 0,
                    transition: { duration: 1, delay: 0.5 },
                  }}
                  viewport={{ once: true }}
                >
                  Technologies Used
                </About>
              </Wrapperft>
              <ListUl
                initial={{ y: "30px", opacity: 0 }}
                whileInView={{
                  y: 0,
                  opacity: 1,
                  transition: { duration: 1, delay: 0.5 },
                }}
                viewport={{ once: true }}
              >
                {item?.tecs?.map((list, i) => (
                  <List key={i}>{list} / </List>
                ))}
              </ListUl>
              {item.giturl && (
                <Wrapperft>
                  <Anchor
                    href={item.giturl}
                    target="_blank"
                    rel="noreferrer"
                    initial={{ y: "20px", opacity: 0 }}
                    whileInView={{ y: "0px", opacity: 1 }}
                    transition={{ duration: 1 }}
                  >
                    Preview
                    <svg width="30" height="18" viewBox="0 0 10 6" fill="none">
                      <path
                        d="M6.71627 0L6.27434 0.441934L8.14928 2.31688H0V2.94189H8.14922L6.27434 4.81678L6.71627 5.25871L9.34566 2.62936L6.71627 0Z"
                        fill="currentColor"
                      />
                    </svg>
                  </Anchor>
                </Wrapperft>
              )}
            </Tech>
          </WrapperContainer>

          {item.fullImage && (
            <motion.img
              src={item.fullImage}
              style={{
                width: "100%",
                borderTop: "6px solid var(--border)",
                display: "block",
              }}
              initial={{ scale: 0.95, opacity: 0 }}
              whileInView={{
                scale: 1,
                opacity: 1,
                transition: { duration: 1 },
              }}
              viewport={{ once: true }}
            />
          )}

          <Footer />
        </React.Fragment>
      );
    }
    return null;
  });
}

export default ProjectPage;

const Wrapper = styled(motion.div)`
  overflow: hidden;
  position: relative;
`;

const Wrapperft = styled(Wrapper)`
  width: fit-content;
`;

const HeroContainer = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #000;
`;

const HeroImg = styled(motion.img)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: grayscale(1);
  display: block;
`;

const TitleContainer = styled(motion.div)`
  margin-bottom: 80px;
  margin-top: -20vh;
  position: relative;
  z-index: 9;
`;

const ProjectType = styled(motion.h4)`
  text-align: center;
  color: white;
  margin-top: 10px;
`;

const Title = styled(motion.h2)`
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #565454;
  text-align: center;
  color: #fff;
  font-size: 100px;
  line-height: 110px;

  @media (max-width: 768px) {
    font-size: 48px;
    line-height: 56px;
  }
`;

const WrapperContainer = styled(motion.div)`
  max-width: 1200px;
  margin: auto;
  min-height: 100vh;
  padding: 100px 20px;
`;

const About = styled(motion.h2)`
  font-size: 80px;
  color: var(--text);

  @media (max-width: 768px) {
    font-size: 40px;
  }
`;

const Pera = styled(motion.p)`
  font-size: 22px;
  line-height: 50px;
  color: var(--text-3);
`;

const BottomContainer = styled(motion.div)`
  display: flex;
  gap: 20px;
  margin-top: 80px;

  ${Wrapperft} {
    margin-bottom: 30px;
  }
`;

const Tech = styled(motion.div)``;

const ListUl = styled(motion.ul)`
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  max-width: 546px;
  gap: 20px;
`;

const List = styled(motion.li)`
  list-style: none;
  font-size: 17px;
  color: var(--text-4);
`;

const Anchor = styled(motion.a)`
  text-decoration: none;
  font-size: 18px;
  text-transform: capitalize;
  position: relative;
  background: none;
  border: none;
  outline: none;
  color: var(--text);
  margin-top: 50px;
  display: flex;
  align-items: center;
  padding: 20px 40px;
  z-index: 1;
  width: fit-content;
  gap: 20px;

  &::after {
    position: absolute;
    content: "";
    width: 50px;
    height: 50px;
    background: var(--btn-bg);
    z-index: -1;
    display: block;
    left: 0px;
    top: 0;
    bottom: 0;
    transition: 0.8s ease;
    border-radius: 50%;
  }
  &:hover::after {
    width: 100%;
    height: 100%;
    border-radius: 30px;
  }
`;

const RevealBar = styled(motion.div)`
  background: var(--overlay);
  transition: background 0.3s ease;
`;
